import { Component} from '@angular/core';
 
@Component({
    selector: 'app-emprestimo',
    templateUrl: './emprestimo.component.html',
    styleUrls: ['./emprestimo.component.scss']
})


export class emprestimoComponent {}